export class Admin {
    private user_id: string;
    private password: string;

    constructor(username, password) {
        this.user_id = username;
        this.password = password;
    }
}

export class ForgotEmail {
    private email: string;

    constructor(email) {
        this.email = email;
    }
}

export class PasswordChange {
    private user_id: string;
    private password: string;
    private confirm: string;
    private token: string;

    constructor(user_id, password, password2, token) {
        this.user_id = user_id;
        this.password = password;
        this.confirm = password2;
        this.token = token;
    }
}

export class RegisterUser {
    constructor(
        private first_name: string,
        private admin_id: string,
        private last_name: string,
        private company: string,
        private country: string,
        private email: string,
        private password: string,
        private account_type: string,
        private user_id: string,
        private subscription: string
    ) { }
}

export class UserUpdate {
    constructor(
        private first_name: string,
        private last_name: string,
        private email: string,
        private account_type: string,
        private subscription:string
    ) { }
}

export class UserCls {
    constructor(
        private name: string,
        private first_name: string,
        private last_name: string,
        private user_id: string,
        private admin_id: string,
        private company: string,
        private country: string,
        private account_type: string,
        private email: string,
        private date: string,
        private readWriteAPI: string,
        private readAPI: string,
        public subscription: string,
        private expired_date: string,
        private trial:boolean
    ) { }
}

export class ManagerCls {
    private name: any;
    private first_name: any;
    private last_name: any;
    private admin_id: any;
    private admin_type:any;
    private plan_model : any;
    private license_type: any;
    private organisation: any;
    private country: any;
    private sub_account_type: any; 
    private sub_account_limit: any;
    private email: any;
    private mobile:any;
    private start_date: any;
    private expire_date: any;
    private status:any;
    private installation_date:any;
    private remarks:any;
    private transaction:any;
    private pic : any;
    private permission_level:any;
    private hosting:any;
    private tier: any;

    constructor(data:any) {
         this.name = data.first_name + " "+ data.last_name;
         this.first_name = data.first_name;
         this.last_name = data.last_name;
         this.admin_id = data.admin_id;
         this.admin_type = data.admin_type;
         this.plan_model = data.plan_model;
         this.license_type = data.license_type;
         this.organisation = data.organisation;
         this.country = data.country;
         this.sub_account_type = data.sub_account_type;
         this.sub_account_limit = data.sub_account_limit;
         this.email = data.email;
         this.mobile = data.mobile;
         this.start_date = data.start_date;
         this.expire_date = data.expire_date;
         this.status = data.status;
         this.installation_date = data.installation_date;
         this.remarks = data.remarks;
         this.pic = data.pic;
         this.permission_level = data.permission_level;
         this.hosting = data.hosting;
         this.tier = data.tier;
     }
}

export class TransactionCls {
    constructor(
        private user_id,
        private name,
        private email,
        private date,
        private orderid,
        private item,
        private price,
        private payType,
        private address,
        private phone,
        private plan_type
    ) { }
}

export interface TransactionsIFace {
    from: string;
    data: {
        user_id;
        name;
        email;
        date;
        orderid;
        item;
        price;
        payType;
        address;
        phone;
        plan_type;
    };
}

export interface UserIFace {
    from: string;
    data: {
        name: string;
        first_name: string;
        last_name: string;
        user_id: string;
        admin_id: string;
        company: string;
        country: string;
        account_type: string;
        subscription: string;
        email: string;
        date: string;
        readWriteAPI: string;
        readAPI: string;
    };
}

export interface ManagerIFace {
    from: string;
    data: {
        name: string;
        first_name: string;
        last_name: string;
        user_id: string;
        admin_id: string;
        company: string;
        country: string;
        account_type: string;
        subscription: string;
        email: string;
        date: string;
        readWriteAPI: string;
        readAPI: string;
    };
}

export class VoucherCls {
    constructor(
        private id,
        private type,
        private code,
        private discount,
        private extendYear,
        private date,
        private expired,
        private count,
        private isTraining,
        private status,
        private category,
        private totalCount,
        private duration,
        private subscription_type,
        private account_type,
        private plan_type
    ) { }
}

export interface VoucherIFace {
    from: string;
    data: {
        type: string;
        code: string;
        discount: string;
        extendYear: string;
        isTraining: boolean;
        date: string;
        expired: string;
        count: string,
        status: string,
        category: string,
        totalCount: Number,
        subscription_type:string,
        duration:string,
        account_type:string,
        plan_type:string
    };
}

export class VoucherEdit {
    constructor(
        private voucherid,
        private discount,
        private count,
        private date_expired,
        private description: string,
        private status: string,
        private category: string) { }
}

export class Redeem {
    constructor(
        private redeem_id,
        private account,
        private amount,
        private bank_name,
        private date,
        private full_name,
        private user_id,
        private email,
        private phone,
        private refCode,
        private status,
        private referrals_ids
    ) { }
}

export interface RedeemIFace {
    id: string;
    account: string;
    amount: string;
    bank_name: string;
    date: string;
    full_name: string;
    user_id: string;
    email: string;
    phone: string;
    refCode: string;
    status: string;
}


export interface LicenseIFace {
    from: string;
    data: {
        id: string;
        first_name: string;
        last_name: string;
        organization: string;
        email: string;
        phone: string;
        expired_date: string;
        created_at: string;
        serial: string;
        app_version: string;
    };
}
export class Message {
    public type: MessageType;
    public message: string;
}

export enum MessageType {
    Success,
    Error,
    Info,
    Warning
}

export enum WHAT {
    Summary,
    Users,
    Managers,
    Admin,
    userDetails,
    Transactions,
    Vouchers,
    Licenses,
    UsersAnalysis,
    Data,
    SummaryByYear,
    SummaryByMonth,
    SummaryByMonthYear,
    RedeemList,
    Country,
    CountryAlt
}
